import { render, staticRenderFns } from "./CompletedWaivers.vue?vue&type=template&id=35f3dd8c&scoped=true"
import script from "./CompletedWaivers.vue?vue&type=script&lang=js"
export * from "./CompletedWaivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f3dd8c",
  null
  
)

export default component.exports